import { render, staticRenderFns } from "./PriceAdjust.vue?vue&type=template&id=37f86136"
import script from "./PriceAdjust.vue?vue&type=script&lang=ts"
export * from "./PriceAdjust.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports